
document.addEventListener("DOMContentLoaded", function () {
  var countries = [
    { code: "US", dial: "+1",   name: "United States" },
    { code: "AU", dial: "+61",  name: "Australia" },
    { code: "AF", dial: "+93",  name: "Afghanistan" },
    { code: "AL", dial: "+355", name: "Albania" },
    { code: "DZ", dial: "+213", name: "Algeria" },
    { code: "AD", dial: "+376", name: "Andorra" },
    { code: "AO", dial: "+244", name: "Angola" },
    { code: "AR", dial: "+54",  name: "Argentina" },
    { code: "AM", dial: "+374", name: "Armenia" },
    { code: "AW", dial: "+297", name: "Aruba" },
    { code: "AT", dial: "+43",  name: "Austria" },
    { code: "AZ", dial: "+994", name: "Azerbaijan" },
    { code: "BS", dial: "+1",   name: "Bahamas" },
    { code: "BH", dial: "+973", name: "Bahrain" },
    { code: "BD", dial: "+880", name: "Bangladesh" },
    { code: "BB", dial: "+1",   name: "Barbados" },
    { code: "BY", dial: "+375", name: "Belarus" },
    { code: "BE", dial: "+32",  name: "Belgium" },
    { code: "BZ", dial: "+501", name: "Belize" },
    { code: "BJ", dial: "+229", name: "Benin" },
    { code: "BM", dial: "+1",   name: "Bermuda" },
    { code: "BT", dial: "+975", name: "Bhutan" },
    { code: "BO", dial: "+591", name: "Bolivia" },
    { code: "BA", dial: "+387", name: "Bosnia and Herzegovina" },
    { code: "BW", dial: "+267", name: "Botswana" },
    { code: "BR", dial: "+55",  name: "Brazil" },
    { code: "BN", dial: "+673", name: "Brunei" },
    { code: "BG", dial: "+359", name: "Bulgaria" },
    { code: "BF", dial: "+226", name: "Burkina Faso" },
    { code: "BI", dial: "+257", name: "Burundi" },
    { code: "KH", dial: "+855", name: "Cambodia" },
    { code: "CM", dial: "+237", name: "Cameroon" },
    { code: "CA", dial: "+1",   name: "Canada" },
    { code: "CV", dial: "+238", name: "Cape Verde" },
    { code: "KY", dial: "+1",   name: "Cayman Islands" },
    { code: "CF", dial: "+236", name: "Central African Republic" },
    { code: "TD", dial: "+235", name: "Chad" },
    { code: "CL", dial: "+56",  name: "Chile" },
    { code: "CN", dial: "+86",  name: "China" },
    { code: "CO", dial: "+57",  name: "Colombia" },
    { code: "KM", dial: "+269", name: "Comoros" },
    { code: "CD", dial: "+243", name: "Congo (DRC)" },
    { code: "CG", dial: "+242", name: "Congo (Republic)" },
    { code: "CR", dial: "+506", name: "Costa Rica" },
    { code: "CI", dial: "+225", name: "Côte d'Ivoire" },
    { code: "HR", dial: "+385", name: "Croatia" },
    { code: "CU", dial: "+53",  name: "Cuba" },
    { code: "CY", dial: "+357", name: "Cyprus" },
    { code: "CZ", dial: "+420", name: "Czech Republic" },
    { code: "DK", dial: "+45",  name: "Denmark" },
    { code: "DJ", dial: "+253", name: "Djibouti" },
    { code: "DM", dial: "+1",   name: "Dominica" },
    { code: "DO", dial: "+1",   name: "Dominican Republic" },
    { code: "EC", dial: "+593", name: "Ecuador" },
    { code: "EG", dial: "+20",  name: "Egypt" },
    { code: "SV", dial: "+503", name: "El Salvador" },
    { code: "GQ", dial: "+240", name: "Equatorial Guinea" },
    { code: "ER", dial: "+291", name: "Eritrea" },
    { code: "EE", dial: "+372", name: "Estonia" },
    { code: "ET", dial: "+251", name: "Ethiopia" },
    { code: "FJ", dial: "+679", name: "Fiji" },
    { code: "FI", dial: "+358", name: "Finland" },
    { code: "FR", dial: "+33",  name: "France" },
    { code: "PF", dial: "+689", name: "French Polynesia" },
    { code: "GA", dial: "+241", name: "Gabon" },
    { code: "GM", dial: "+220", name: "Gambia" },
    { code: "GE", dial: "+995", name: "Georgia" },
    { code: "DE", dial: "+49",  name: "Germany" },
    { code: "GH", dial: "+233", name: "Ghana" },
    { code: "GR", dial: "+30",  name: "Greece" },
    { code: "GL", dial: "+299", name: "Greenland" },
    { code: "GD", dial: "+1",   name: "Grenada" },
    { code: "GP", dial: "+590", name: "Guadeloupe" },
    { code: "GU", dial: "+1",   name: "Guam" },
    { code: "GT", dial: "+502", name: "Guatemala" },
    { code: "GN", dial: "+224", name: "Guinea" },
    { code: "GW", dial: "+245", name: "Guinea-Bissau" },
    { code: "GY", dial: "+592", name: "Guyana" },
    { code: "HT", dial: "+509", name: "Haiti" },
    { code: "HN", dial: "+504", name: "Honduras" },
    { code: "HK", dial: "+852", name: "Hong Kong" },
    { code: "HU", dial: "+36",  name: "Hungary" },
    { code: "IS", dial: "+354", name: "Iceland" },
    { code: "IN", dial: "+91",  name: "India" },
    { code: "ID", dial: "+62",  name: "Indonesia" },
    { code: "IR", dial: "+98",  name: "Iran" },
    { code: "IQ", dial: "+964", name: "Iraq" },
    { code: "IE", dial: "+353", name: "Ireland" },
    { code: "IL", dial: "+972", name: "Israel" },
    { code: "IT", dial: "+39",  name: "Italy" },
    { code: "JM", dial: "+1",   name: "Jamaica" },
    { code: "JP", dial: "+81",  name: "Japan" },
    { code: "JO", dial: "+962", name: "Jordan" },
    { code: "KZ", dial: "+7",   name: "Kazakhstan" },
    { code: "KE", dial: "+254", name: "Kenya" },
    { code: "KI", dial: "+686", name: "Kiribati" },
    { code: "KW", dial: "+965", name: "Kuwait" },
    { code: "KG", dial: "+996", name: "Kyrgyzstan" },
    { code: "LA", dial: "+856", name: "Laos" },
    { code: "LV", dial: "+371", name: "Latvia" },
    { code: "LB", dial: "+961", name: "Lebanon" },
    { code: "LS", dial: "+266", name: "Lesotho" },
    { code: "LR", dial: "+231", name: "Liberia" },
    { code: "LY", dial: "+218", name: "Libya" },
    { code: "LI", dial: "+423", name: "Liechtenstein" },
    { code: "LT", dial: "+370", name: "Lithuania" },
    { code: "LU", dial: "+352", name: "Luxembourg" },
    { code: "MO", dial: "+853", name: "Macau" },
    { code: "MG", dial: "+261", name: "Madagascar" },
    { code: "MW", dial: "+265", name: "Malawi" },
    { code: "MY", dial: "+60",  name: "Malaysia" },
    { code: "MV", dial: "+960", name: "Maldives" },
    { code: "ML", dial: "+223", name: "Mali" },
    { code: "MT", dial: "+356", name: "Malta" },
    { code: "MH", dial: "+692", name: "Marshall Islands" },
    { code: "MR", dial: "+222", name: "Mauritania" },
    { code: "MU", dial: "+230", name: "Mauritius" },
    { code: "MX", dial: "+52",  name: "Mexico" },
    { code: "FM", dial: "+691", name: "Micronesia" },
    { code: "MD", dial: "+373", name: "Moldova" },
    { code: "MC", dial: "+377", name: "Monaco" },
    { code: "MN", dial: "+976", name: "Mongolia" },
    { code: "ME", dial: "+382", name: "Montenegro" },
    { code: "MA", dial: "+212", name: "Morocco" },
    { code: "MZ", dial: "+258", name: "Mozambique" },
    { code: "MM", dial: "+95",  name: "Myanmar" },
    { code: "NA", dial: "+264", name: "Namibia" },
    { code: "NR", dial: "+674", name: "Nauru" },
    { code: "NP", dial: "+977", name: "Nepal" },
    { code: "NL", dial: "+31",  name: "Netherlands" },
    { code: "NC", dial: "+687", name: "New Caledonia" },
    { code: "NZ", dial: "+64",  name: "New Zealand" },
    { code: "NI", dial: "+505", name: "Nicaragua" },
    { code: "NE", dial: "+227", name: "Niger" },
    { code: "NG", dial: "+234", name: "Nigeria" },
    { code: "KP", dial: "+850", name: "North Korea" },
    { code: "MK", dial: "+389", name: "North Macedonia" },
    { code: "NO", dial: "+47",  name: "Norway" },
    { code: "OM", dial: "+968", name: "Oman" },
    { code: "PK", dial: "+92",  name: "Pakistan" },
    { code: "PW", dial: "+680", name: "Palau" },
    { code: "PS", dial: "+970", name: "Palestine" },
    { code: "PA", dial: "+507", name: "Panama" },
    { code: "PG", dial: "+675", name: "Papua New Guinea" },
    { code: "PY", dial: "+595", name: "Paraguay" },
    { code: "PE", dial: "+51",  name: "Peru" },
    { code: "PH", dial: "+63",  name: "Philippines" },
    { code: "PL", dial: "+48",  name: "Poland" },
    { code: "PT", dial: "+351", name: "Portugal" },
    { code: "PR", dial: "+1",   name: "Puerto Rico" },
    { code: "QA", dial: "+974", name: "Qatar" },
    { code: "RO", dial: "+40",  name: "Romania" },
    { code: "RU", dial: "+7",   name: "Russia" },
    { code: "RW", dial: "+250", name: "Rwanda" },
    { code: "WS", dial: "+685", name: "Samoa" },
    { code: "SM", dial: "+378", name: "San Marino" },
    { code: "SA", dial: "+966", name: "Saudi Arabia" },
    { code: "SN", dial: "+221", name: "Senegal" },
    { code: "RS", dial: "+381", name: "Serbia" },
    { code: "SC", dial: "+248", name: "Seychelles" },
    { code: "SL", dial: "+232", name: "Sierra Leone" },
    { code: "SG", dial: "+65",  name: "Singapore" },
    { code: "SK", dial: "+421", name: "Slovakia" },
    { code: "SI", dial: "+386", name: "Slovenia" },
    { code: "SB", dial: "+677", name: "Solomon Islands" },
    { code: "SO", dial: "+252", name: "Somalia" },
    { code: "ZA", dial: "+27",  name: "South Africa" },
    { code: "KR", dial: "+82",  name: "South Korea" },
    { code: "SS", dial: "+211", name: "South Sudan" },
    { code: "ES", dial: "+34",  name: "Spain" },
    { code: "LK", dial: "+94",  name: "Sri Lanka" },
    { code: "SD", dial: "+249", name: "Sudan" },
    { code: "SR", dial: "+597", name: "Suriname" },
    { code: "SE", dial: "+46",  name: "Sweden" },
    { code: "CH", dial: "+41",  name: "Switzerland" },
    { code: "SY", dial: "+963", name: "Syria" },
    { code: "TW", dial: "+886", name: "Taiwan" },
    { code: "TJ", dial: "+992", name: "Tajikistan" },
    { code: "TZ", dial: "+255", name: "Tanzania" },
    { code: "TH", dial: "+66",  name: "Thailand" },
    { code: "TG", dial: "+228", name: "Togo" },
    { code: "TO", dial: "+676", name: "Tonga" },
    { code: "TT", dial: "+1",   name: "Trinidad and Tobago" },
    { code: "TN", dial: "+216", name: "Tunisia" },
    { code: "TR", dial: "+90",  name: "Turkey" },
    { code: "TM", dial: "+993", name: "Turkmenistan" },
    { code: "UG", dial: "+256", name: "Uganda" },
    { code: "UA", dial: "+380", name: "Ukraine" },
    { code: "AE", dial: "+971", name: "United Arab Emirates" },
    { code: "GB", dial: "+44",  name: "United Kingdom" },
    { code: "UY", dial: "+598", name: "Uruguay" },
    { code: "UZ", dial: "+998", name: "Uzbekistan" },
    { code: "VU", dial: "+678", name: "Vanuatu" },
    { code: "VE", dial: "+58",  name: "Venezuela" },
    { code: "VN", dial: "+84",  name: "Vietnam" },
    { code: "YE", dial: "+967", name: "Yemen" },
    { code: "ZM", dial: "+260", name: "Zambia" },
    { code: "ZW", dial: "+263", name: "Zimbabwe" },
  ];

  function flagUrl(code) {
    return "//cdn.shopify.com/static/images/flags/" + code.toLowerCase() + ".svg?width=20";
  }

  function detectCountry() {
    var shopIso = (window.SHOP_COUNTRY_ISO || "").toUpperCase();
    if (shopIso && countries.some(function (c) { return c.code === shopIso; })) return shopIso;

    var lang = (navigator.language || "").toUpperCase();
    if (lang.indexOf("PT-BR") !== -1) return "BR";
    if (lang.indexOf("EN-AU") !== -1) return "AU";
    if (lang.indexOf("EN-NZ") !== -1) return "NZ";
    if (lang.indexOf("EN-GB") !== -1) return "GB";
    if (lang.indexOf("EN-CA") !== -1) return "CA";
    return "US";
  }

  function init(input) {
    if (!input) return null;
    var isContactForm = input.id === "ContactForm-phone-sms";
    var field = input.closest(".field") || input.closest(".return-field") || input.parentNode;
    if (!field || field.querySelector(".phone-country-wrap")) return null;

    var wrapper = document.createElement("div");
    wrapper.className = "phone-country-wrap";

    var dropdown = document.createElement("div");
    dropdown.className = "phone-country-dropdown";
    dropdown.dataset.open = "false";

    var button = document.createElement("button");
    button.type = "button";
    button.className = "phone-country-button";
    button.setAttribute("aria-haspopup", "listbox");
    button.setAttribute("aria-expanded", "false");
    button.setAttribute("aria-label", "Country code");

    var flagImg = document.createElement("img");
    flagImg.className = "phone-country-flag";
    flagImg.alt = "";
    flagImg.setAttribute("aria-hidden", "true");
    button.appendChild(flagImg);

    var dialSpan = document.createElement("span");
    dialSpan.className = "phone-country-dial";
    button.appendChild(dialSpan);

    var chevron = document.createElement("span");
    chevron.className = "phone-country-chevron";
    chevron.setAttribute("aria-hidden", "true");
    chevron.innerHTML = '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    button.appendChild(chevron);
    dropdown.appendChild(button);

    var panel = document.createElement("div");
    panel.className = "phone-country-panel";

    var search = document.createElement("input");
    search.type = "search";
    search.placeholder = "Search country…";
    search.className = "phone-country-search";
    search.setAttribute("aria-label", "Search country");
    search.autocomplete = "off";
    panel.appendChild(search);

    var list = document.createElement("ul");
    list.className = "phone-country-list";
    list.setAttribute("role", "listbox");

    countries.forEach(function (c) {
      var li = document.createElement("li");
      li.className = "phone-country-option";
      li.dataset.code = c.code;
      li.dataset.dial = c.dial;
      li.dataset.name = c.name;
      li.setAttribute("role", "option");

      var img = document.createElement("img");
      img.className = "phone-country-flag";
      img.src = flagUrl(c.code);
      img.alt = "";
      img.setAttribute("aria-hidden", "true");
      img.loading = "lazy";
      li.appendChild(img);

      var nameSpan = document.createElement("span");
      nameSpan.className = "phone-country-name";
      nameSpan.textContent = c.name;
      li.appendChild(nameSpan);

      var dialCode = document.createElement("span");
      dialCode.className = "phone-country-dial-code";
      dialCode.textContent = c.dial;
      li.appendChild(dialCode);

      li.addEventListener("click", function () {
        selectCountry(c);
        closeDropdown();
      });

      list.appendChild(li);
    });
    panel.appendChild(list);
    dropdown.appendChild(panel);

    var currentCountry = null;
    function selectCountry(c) {
      currentCountry = c;
      flagImg.src = flagUrl(c.code);
      flagImg.alt = c.name;
      dialSpan.textContent = c.dial;
      wrapper.dataset.dial = c.dial;
      wrapper.dataset.code = c.code;
      list.querySelectorAll(".phone-country-option").forEach(function (opt) {
        opt.setAttribute("aria-selected", opt.dataset.code === c.code ? "true" : "false");
      });
    }

    function openDropdown() {
      dropdown.dataset.open = "true";
      button.setAttribute("aria-expanded", "true");
      search.value = "";
      list.querySelectorAll(".phone-country-option.is-hidden").forEach(function (opt) {
        opt.classList.remove("is-hidden");
      });
      setTimeout(function () { search.focus(); }, 30);
    }

    function closeDropdown() {
      dropdown.dataset.open = "false";
      button.setAttribute("aria-expanded", "false");
    }

    button.addEventListener("click", function (e) {
      e.stopPropagation();
      if (dropdown.dataset.open === "true") closeDropdown();
      else openDropdown();
    });

    search.addEventListener("click", function (e) { e.stopPropagation(); });
    search.addEventListener("input", function () {
      var q = search.value.trim().toLowerCase();
      list.querySelectorAll(".phone-country-option").forEach(function (opt) {
        var name = (opt.dataset.name || "").toLowerCase();
        var code = (opt.dataset.code || "").toLowerCase();
        var dial = (opt.dataset.dial || "").toLowerCase();
        var match = !q || name.indexOf(q) !== -1 || code.indexOf(q) !== -1 || dial.indexOf(q) !== -1;
        opt.classList.toggle("is-hidden", !match);
      });
    });

    document.addEventListener("click", function (e) {
      if (!dropdown.contains(e.target)) closeDropdown();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && dropdown.dataset.open === "true") closeDropdown();
    });

    var detected = detectCountry();
    var initial = countries.find(function (c) { return c.code === detected; }) || countries.find(function (c) { return c.code === "US"; });
    selectCountry(initial);

    input.classList.add("phone-country-input");
    field.classList.add("phone-country-field");

    input.parentNode.insertBefore(wrapper, input);
    wrapper.appendChild(dropdown);
    wrapper.appendChild(input);

    if (isContactForm) {
      var hiddenFullPhone = document.createElement("input");
      hiddenFullPhone.type = "hidden";
      hiddenFullPhone.name = "contact[phone_sms_full]";
      hiddenFullPhone.id = "ContactForm-phone-sms-full";
      field.appendChild(hiddenFullPhone);

      var form = input.closest("form");
      if (form) {
        form.addEventListener("submit", function () {
          var raw = input.value.trim();
          if (!raw) { hiddenFullPhone.value = ""; return; }
          var dial = currentCountry ? currentCountry.dial : "";
          hiddenFullPhone.value = dial + " " + raw.replace(/[^\d]/g, "");
          input.value = hiddenFullPhone.value;
        });
      }
    }
  }

  function setupItiOn(input) {
    if (!input || !window.intlTelInput) return null;
    var iti = window.intlTelInput(input, {
      initialCountry: "auto",
      geoIpLookup: function (success) {
        fetch("https://api.country.is/", { cache: "force-cache" })
          .then(function (r) { return r.json(); })
          .then(function (d) { success(d && d.country ? d.country : "au"); })
          .catch(function () { success("au"); });
      },
      preferredCountries: ["au", "us", "gb", "nz", "ca", "ie"],
      separateDialCode: true,
      autoPlaceholder: "polite",
      utilsScript: (window.GL_ITI_UTILS_URL || "https://cdn.jsdelivr.net/npm/intl-tel-input@18.2.1/build/js/utils.js")
    });
    return iti;
  }

  var contactPhoneInput = document.getElementById("ContactForm-phone-sms");
  if (contactPhoneInput) {
    var contactField = contactPhoneInput.closest(".field") || contactPhoneInput.parentNode;
    var contactForm = contactPhoneInput.closest("form");

    var hiddenContactPhone = document.createElement("input");
    hiddenContactPhone.type = "hidden";
    hiddenContactPhone.name = "contact[phone_sms_full]";
    hiddenContactPhone.id = "ContactForm-phone-sms-full";
    contactField.appendChild(hiddenContactPhone);

    var contactPhoneError = document.createElement("span");
    contactPhoneError.id = "ContactForm-phone-sms-error";
    contactPhoneError.className = "contact-form-field-error";
    contactPhoneError.setAttribute("aria-live", "polite");
    contactField.appendChild(contactPhoneError);

    function showContactPhoneError(msg) {
      contactPhoneError.textContent = msg || "";
      contactPhoneError.classList.toggle("is-visible", !!msg);
      contactPhoneInput.classList.toggle("iti-invalid", !!msg);
    }
    contactPhoneInput.addEventListener("input", function () {
      if (contactPhoneError.textContent) showContactPhoneError("");
    });

    var contactIti = setupItiOn(contactPhoneInput);
    if (contactIti) window.__GOLDY_CONTACT_ITI = contactIti;

    if (contactForm) {

      contactForm.addEventListener("submit", function (e) {
        var iti = window.__GOLDY_CONTACT_ITI;
        var raw = contactPhoneInput.value.trim();
        if (!raw) {
          hiddenContactPhone.value = "";
          showContactPhoneError("");
          return;
        }
        if (iti && typeof iti.isValidNumber === "function") {
          if (!iti.isValidNumber()) {
            e.preventDefault();
            e.stopImmediatePropagation();
            var country = (iti.getSelectedCountryData() || {}).name || "the selected country";
            showContactPhoneError("Please enter a valid phone number for " + country + ".");
            contactPhoneInput.focus();
            return;
          }
          showContactPhoneError("");
          hiddenContactPhone.value = iti.getNumber();
          contactPhoneInput.value = iti.getNumber();
          return;
        }

        var digitsOnly = raw.replace(/\D/g, "");
        if (digitsOnly.length < 7) {
          e.preventDefault();
          e.stopImmediatePropagation();
          showContactPhoneError("Please enter a valid phone number.");
          contactPhoneInput.focus();
          return;
        }
        showContactPhoneError("");
        hiddenContactPhone.value = raw;
      }, true);
    }
  }

  var returnPhoneInput = document.querySelector("#returnForm input[name='phone']");
  if (returnPhoneInput) {
    var returnIti = setupItiOn(returnPhoneInput);
    if (returnIti) {
      window.__GOLDY_RETURN_ITI = returnIti;
    }
  }

  var customOrderSuccess = document.getElementById("successMessage");
  if (customOrderSuccess) {
    var hideChrome = function () {
      if (customOrderSuccess.classList.contains("hidden")) return;
      customOrderSuccess.dataset.shown = "true";
      [".form-header", ".form-trust", ".form-cta", ".steps", ".nav-buttons"].forEach(function (sel) {
        var el = document.querySelector(sel);
        if (el) el.style.display = "none";
      });
      document.querySelectorAll(".step-panel").forEach(function (p) {
        p.style.display = "none";
      });
    };
    new MutationObserver(hideChrome).observe(customOrderSuccess, {
      attributes: true,
      attributeFilter: ["class"]
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  var form = document.getElementById("returnForm");
  if (!form) return;

  var RETURN_API_URL = "https://custom-order-production.up.railway.app/api/submit-return";

  var currentStep = 1;
  var nextBtn = document.getElementById("nextBtn");
  var prevBtn = document.getElementById("prevBtn");
  var steps = document.querySelectorAll(".return-step");
  var panels = document.querySelectorAll(".return-panel");
  var hint = document.getElementById("stepHint");

  var formRenderedAt = Date.now();
  var MIN_FILL_MS = 3000;
  var honeypot = form.querySelector('input[name="company_website"]');

  var EMAIL_RX = /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z]{2,})+$/;

  var DISPOSABLE = {
    "mailinator.com":1,"mailinator.net":1,"mailinator2.com":1,
    "tempmail.com":1,"temp-mail.org":1,"temp-mail.io":1,"tempmailaddress.com":1,"tmpmail.org":1,"tmpmail.net":1,
    "10minutemail.com":1,"10minutemail.net":1,"20minutemail.com":1,"30minutemail.com":1,
    "guerrillamail.com":1,"guerrillamail.net":1,"guerrillamail.org":1,"guerrillamail.biz":1,"guerrillamail.de":1,"sharklasers.com":1,
    "yopmail.com":1,"yopmail.fr":1,"yopmail.net":1,
    "trashmail.com":1,"trashmail.net":1,"trashmail.io":1,"trashmail.de":1,
    "throwawaymail.com":1,"getnada.com":1,"nada.email":1,"maildrop.cc":1,"dispostable.com":1,
    "spam4.me":1,"spambox.us":1,"spambog.com":1,"spamgourmet.com":1,"spamex.com":1,
    "fakeinbox.com":1,"fakemail.net":1,"fakemailgenerator.com":1,
    "mintemail.com":1,"mohmal.com":1,"emailondeck.com":1,"mytemp.email":1,"my10minutemail.com":1,
    "0-mail.com":1,"jetable.org":1,"mailcatch.com":1,"mailnesia.com":1,"mailnull.com":1,
    "tempr.email":1,"tempinbox.com":1,"easytrashmail.com":1,
    "emailfake.com":1,"email-fake.com":1,"tempail.com":1,"tempmailo.com":1,"tempemail.net":1,
    "discard.email":1,"discardmail.com":1,"mailforspam.com":1,"trbvm.com":1
  };

  var TYPO_MAP = {
    "gmial.com":"gmail.com","gmai.com":"gmail.com","gmal.com":"gmail.com","gnail.com":"gmail.com",
    "gmaill.com":"gmail.com","gmail.co":"gmail.com","gmail.cm":"gmail.com","gmail.con":"gmail.com",
    "gemail.com":"gmail.com","gmali.com":"gmail.com",
    "hotmial.com":"hotmail.com","hotmai.com":"hotmail.com","hotnail.com":"hotmail.com",
    "hotmal.com":"hotmail.com","hotmaill.com":"hotmail.com","hotmail.con":"hotmail.com",
    "yaho.com":"yahoo.com","yahooo.com":"yahoo.com","yhoo.com":"yahoo.com","yahho.com":"yahoo.com","yahoo.con":"yahoo.com",
    "outlok.com":"outlook.com","outloo.com":"outlook.com","outloook.com":"outlook.com","outlook.con":"outlook.com",
    "iclou.com":"icloud.com","icould.com":"icloud.com"
  };

  function setError(name, msg) {
    var slot = form.querySelector('[data-error-for="' + name + '"]');
    var input = form.querySelector('[name="' + name + '"]');
    if (slot) slot.textContent = msg || "";
    if (input) input.classList.toggle("invalid", !!msg);
  }
  function clearError(name) { setError(name, ""); }

  function validateEmail(raw) {
    var email = (raw || "").trim().toLowerCase();
    if (!email) return "Email is required.";
    if (email.length > 100) return "Email is too long.";
    if (!EMAIL_RX.test(email)) return "Please enter a valid email address.";
    var domain = email.split("@")[1];
    if (TYPO_MAP[domain]) return "Did you mean " + email.split("@")[0] + "@" + TYPO_MAP[domain] + "?";
    if (DISPOSABLE[domain]) return "Please use a permanent email — temporary inboxes are not accepted.";
    return null;
  }
  function validateOrder(raw) {
    var v = (raw || "").trim();
    if (!v) return "Order number is required.";
    if (!/^[A-Za-z0-9#\-_]{3,32}$/.test(v)) return "Order number contains invalid characters.";
    return null;
  }
  function validateName(raw, label) {
    var v = (raw || "").trim();
    if (!v) return label + " is required.";
    if (v.length < 2) return label + " is too short.";
    if (v.length > 40) return label + " is too long.";
    if (!/^[\p{L}\p{M}'\- ]+$/u.test(v)) return label + " contains invalid characters.";
    return null;
  }
  function validatePhoneOptional(raw) {
    var v = (raw || "").trim();
    if (!v) return null;

    var iti = window.__GOLDY_RETURN_ITI;
    if (iti && typeof iti.isValidNumber === "function") {
      if (!iti.isValidNumber()) {
        var country = (iti.getSelectedCountryData() || {}).name || "the selected country";
        return "Please enter a valid phone number for " + country + ".";
      }
      return null;
    }
    var digits = v.replace(/\D/g, "");
    if (digits.length < 7) return "Phone number is too short.";
    if (digits.length > 20) return "Phone number is too long.";
    if (!/^[\d+\-\s()]+$/.test(v)) return "Phone contains invalid characters.";
    return null;
  }
  function validateDate(raw) {
    if (!raw) return "Delivery date is required.";
    var d = new Date(raw);
    if (isNaN(d.getTime())) return "Invalid date.";
    var today = new Date(); today.setHours(23,59,59,999);
    if (d > today) return "Delivery date cannot be in the future.";
    var oneYearAgo = new Date(); oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
    if (d < oneYearAgo) return "Delivery must be within the last 12 months.";
    return null;
  }
  function validateReason(raw) {
    var v = (raw || "").trim();
    if (!v) return "Reason is required.";
    if (v.length < 10) return "Please give a bit more detail (10+ characters).";
    if (v.length > 1000) return "Reason is too long.";
    return null;
  }

  function focusField(name) {
    var el = form.querySelector('[name="' + name + '"]');
    if (el && typeof el.focus === "function") el.focus();
  }

  function validateStep1() {
    var firstBad = null;
    var fields = [
      ["order_number", validateOrder(form.order_number.value)],
      ["first_name",   validateName(form.first_name.value, "First name")],
      ["last_name",    validateName(form.last_name.value, "Last name")],
      ["email",        validateEmail(form.email.value)],
      ["phone",        validatePhoneOptional(form.phone.value)]
    ];
    fields.forEach(function (pair) {
      setError(pair[0], pair[1]);
      if (pair[1] && !firstBad) firstBad = pair[0];
    });
    if (firstBad) { focusField(firstBad); return false; }
    return true;
  }
  function validateStep2() {
    var firstBad = null;
    var typeChecked = form.querySelector('input[name="type"]:checked');
    setError("type", typeChecked ? "" : "Please choose Refund or Exchange.");
    if (!typeChecked) firstBad = "type";

    var dateErr = validateDate(form.delivery_date.value);
    setError("delivery_date", dateErr);
    if (dateErr && !firstBad) firstBad = "delivery_date";

    var reasonErr = validateReason(form.reason.value);
    setError("reason", reasonErr);
    if (reasonErr && !firstBad) firstBad = "reason";

    if (firstBad) { focusField(firstBad); return false; }
    return true;
  }

  form.querySelectorAll("input[name], textarea[name]").forEach(function (el) {
    el.addEventListener("input", function () { clearError(el.name); });
    el.addEventListener("change", function () { clearError(el.name); });
  });

  function updateUI() {
    panels.forEach(function (p) {
      p.classList.toggle("active", parseInt(p.dataset.panel, 10) === currentStep);
    });
    steps.forEach(function (s) {
      s.classList.toggle("active", parseInt(s.dataset.step, 10) === currentStep);
    });
    hint.textContent = "Step " + currentStep + " of 2";
    prevBtn.style.display = currentStep === 1 ? "none" : "inline-block";
    nextBtn.textContent = currentStep === 2 ? "Submit" : "Next step";
  }

  function setSubmitting(isSubmitting) {
    nextBtn.disabled = isSubmitting;
    nextBtn.style.opacity = isSubmitting ? "0.7" : "";
    nextBtn.style.cursor = isSubmitting ? "wait" : "";
    nextBtn.textContent = isSubmitting
      ? "Sending…"
      : (currentStep === 2 ? "Submit" : "Next step");
  }

  function showFormMessage(type, msg) {
    var box = form.querySelector(".return-form-message");
    if (!box) {
      box = document.createElement("div");
      box.className = "return-form-message";
      hint.parentNode.insertBefore(box, hint);
    }
    box.classList.remove("is-success", "is-error");
    box.classList.add(type === "success" ? "is-success" : "is-error");
    box.textContent = msg;
  }

  function showSuccessState(email) {
    var success = document.getElementById("returnSuccess");
    var stepsEl = document.querySelector(".return-steps");
    var headerEl = document.querySelector(".return-form-header");
    if (!success) return;

    var emailEl = document.getElementById("returnSuccessEmail");
    if (emailEl && email) emailEl.textContent = email;

    form.style.display = "none";
    if (stepsEl) stepsEl.style.display = "none";
    if (headerEl) headerEl.style.display = "none";
    success.classList.add("is-visible");

    if (success.scrollIntoView) {
      success.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  nextBtn.addEventListener("click", function () {
    if (currentStep === 1) {
      if (!validateStep1()) return;
      currentStep = 2;
      updateUI();
      return;
    }
    if (!validateStep2()) return;

    if (honeypot && honeypot.value.trim() !== "") {
      showFormMessage("success", "Request submitted.");
      return;
    }
    if (Date.now() - formRenderedAt < MIN_FILL_MS) {
      showFormMessage("error", "Please take a moment to review your information before submitting.");
      return;
    }

    var checkedType = form.querySelector('input[name="type"]:checked');

    var phoneRaw = form.phone.value.trim();
    var returnIti = window.__GOLDY_RETURN_ITI;
    var fullPhone = "";
    var phoneCountryIso = "";
    if (phoneRaw) {
      if (returnIti && typeof returnIti.getNumber === "function") {
        fullPhone = returnIti.getNumber() || phoneRaw;
        phoneCountryIso = ((returnIti.getSelectedCountryData() || {}).iso2 || "").toUpperCase();
      } else {
        var phoneWrap = form.phone.closest(".phone-country-wrap");
        var dial = phoneWrap ? (phoneWrap.dataset.dial || "") : "";
        fullPhone = dial + " " + phoneRaw.replace(/\D/g, "");
        phoneCountryIso = phoneWrap ? (phoneWrap.dataset.code || "") : "";
      }
    }

    var payload = {
      orderNumber:  form.order_number.value.trim(),
      firstName:    form.first_name.value.trim(),
      lastName:     form.last_name.value.trim(),
      email:        form.email.value.trim().toLowerCase(),
      phone:            fullPhone,
      phoneCountryCode: phoneCountryIso,
      country:          phoneCountryIso,
      returnType:   checkedType ? checkedType.value : "",
      deliveryDate: form.delivery_date.value,
      reason:       form.reason.value.trim(),

      company_website: form.company_website ? form.company_website.value : ""
    };

    setSubmitting(true);
    fetch(RETURN_API_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok || result.data.success === false) {
          showFormMessage("error", (result.data && result.data.message) || "We couldn't submit your request. Please try again.");
          return;
        }
        showSuccessState(payload.email);
      })
      .catch(function () {
        showFormMessage("error", "Network error. Please check your connection and try again.");
      })
      .then(function () {
        setSubmitting(false);
      });
  });

  prevBtn.addEventListener("click", function () {
    if (currentStep > 1) { currentStep--; updateUI(); }
  });

  document.querySelectorAll(".return-pill").forEach(function (pill) {
    pill.addEventListener("click", function () {
      document.querySelectorAll(".return-pill").forEach(function (p) { p.classList.remove("active"); });
      this.classList.add("active");
      clearError("type");
    });
  });

  var dateInput = form.delivery_date;
  if (dateInput) {
    var today = new Date().toISOString().split("T")[0];
    dateInput.setAttribute("max", today);
    var minDate = new Date();
    minDate.setFullYear(minDate.getFullYear() - 1);
    dateInput.setAttribute("min", minDate.toISOString().split("T")[0]);
  }

  updateUI();
});

(function () {
  "use strict";

  const API_BASE_URL = "https://custom-order-production.up.railway.app";

  let selectedRegion = null;
  let selectedLocation = null;

  function initWorkWithUs() {
    const regionSelection = document.getElementById("regionSelection");
    const applicationFormContainer = document.getElementById("applicationFormContainer");
    const regionOptions = document.getElementById("regionOptions");
    const locationSelection = document.getElementById("locationSelection");
    const locationOptions = document.getElementById("locationOptions");
    const continueBtn = document.getElementById("continueBtn");
    const form = document.getElementById("applicationForm");
    const formError = document.getElementById("formError");
    const submitBtn = document.getElementById("submitBtn");
    const positionOptionsEl = document.getElementById("positionOptions");
    const cvFileInput = document.getElementById("cvFile");
    const coverLetterFileInput = document.getElementById("coverLetterFile");
    const selectedCvContainer = document.getElementById("selectedCvContainer");
    const selectedCvList = document.getElementById("selectedCvList");
    const selectedCoverLetterContainer = document.getElementById("selectedCoverLetterContainer");
    const selectedCoverLetterList = document.getElementById("selectedCoverLetterList");

    if (!form || !regionSelection) return;

    const locations = {
      usa: [
        { value: "miami", label: "Miami, Florida" },
        { value: "dallas", label: "Dallas, Texas" },
        { value: "tampa-bay", label: "Tampa Bay, Florida" }
      ],
      australia: [{ value: "sydney-chippendale", label: "Sydney, Chippendale" }]
    };

    function showError(msg) {
      if (!msg) {
        formError.classList.add("hidden");
        formError.textContent = "";
        return;
      }
      formError.textContent = msg;
      formError.classList.remove("hidden");
    }

    function isValidEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    function updateContinueButton() {
      continueBtn.disabled = !(selectedRegion && selectedLocation);
    }

    regionOptions.addEventListener("change", e => {
      if (e.target.name !== "region") return;
      selectedRegion = e.target.value;

      regionOptions.querySelectorAll(".pill-option").forEach(p => p.classList.remove("active"));
      e.target.parentElement.classList.add("active");

      locationOptions.innerHTML = "";
      locations[selectedRegion].forEach(loc => {
        const label = document.createElement("label");
        label.className = "pill-option";
        label.innerHTML = `<input type="radio" name="location" value="${loc.value}">${loc.label}`;
        locationOptions.appendChild(label);
      });

      locationSelection.classList.remove("hidden");
      updateContinueButton();
    });

    locationOptions.addEventListener("change", e => {
      if (e.target.name !== "location") return;
      selectedLocation = e.target.value;

      locationOptions.querySelectorAll(".pill-option").forEach(p => p.classList.remove("active"));
      e.target.parentElement.classList.add("active");

      updateContinueButton();
    });

    continueBtn.addEventListener("click", () => {
      if (!selectedRegion || !selectedLocation) return;

      const locInput = document.getElementById("location");
      const label = locations[selectedRegion].find(l => l.value === selectedLocation)?.label;
      if (locInput) locInput.value = label;

      regionSelection.classList.add("hidden");
      applicationFormContainer.classList.remove("hidden");
    });

    form.addEventListener("submit", async e => {
      e.preventDefault();
      showError("");

      const email = document.getElementById("email").value.trim();
      if (!isValidEmail(email)) {
        showError("Please enter a valid email.");
        return;
      }

      if (!cvFileInput.files.length) {
        showError("Please upload your CV.");
        return;
      }

      submitBtn.disabled = true;
      submitBtn.textContent = "Sending...";

      const data = new FormData(form);
      data.append("region", selectedRegion);
      data.append("locationCode", selectedLocation);

      try {
        const res = await fetch(`${API_BASE_URL}/api/submit-application`, {
          method: "POST",
          body: data
        });

        const json = await res.json();
        if (!json.success) throw new Error(json.message);

        document.getElementById("successMessage").classList.remove("hidden");
        form.reset();

      } catch (err) {
        showError(err.message || "Error sending application.");
      } finally {
        submitBtn.disabled = false;
        submitBtn.textContent = "Submit Application";
      }
    });

    positionOptionsEl?.addEventListener("change", e => {
      if (e.target.name !== "position") return;
      positionOptionsEl.querySelectorAll(".pill-option").forEach(p => p.classList.remove("active"));
      e.target.parentElement.classList.add("active");
    });

    cvFileInput?.addEventListener("change", () => {
      selectedCvContainer.classList.toggle("hidden", !cvFileInput.files.length);
      selectedCvList.textContent = cvFileInput.files[0]?.name || "";
    });

    coverLetterFileInput?.addEventListener("change", () => {
      selectedCoverLetterContainer.classList.toggle("hidden", !coverLetterFileInput.files.length);
      selectedCoverLetterList.textContent = coverLetterFileInput.files[0]?.name || "";
    });
  }

  if (document.readyState === "complete" || document.readyState === "interactive") {
    setTimeout(initWorkWithUs, 50);
  } else {
    document.addEventListener("DOMContentLoaded", initWorkWithUs);
  }
})();

(function () {
  function initMultiCheckbox(wrap) {
    if (wrap.dataset.multiCheckboxInit === "true") return;
    var id = wrap.dataset.multiCheckbox;
    if (!id) return;
    var hidden = wrap.querySelector('input[type="hidden"][data-multi-checkbox-hidden="' + id + '"]');
    var sources = wrap.querySelectorAll('input[type="checkbox"][data-multi-checkbox-source="' + id + '"]');
    if (!hidden || !sources.length) return;

    function update() {
      var selected = [];
      sources.forEach(function (cb) { if (cb.checked) selected.push(cb.value); });
      hidden.value = selected.join(", ");
    }

    sources.forEach(function (cb) { cb.addEventListener("change", update); });
    var form = wrap.closest("form");
    if (form) form.addEventListener("submit", update);
    update();
    wrap.dataset.multiCheckboxInit = "true";
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-multi-checkbox]").forEach(initMultiCheckbox);
  });
})();

(function () {
  var MIN_FILL_MS = 3000;

  document.addEventListener("DOMContentLoaded", function () {
    var form = document.getElementById("ContactForm");
    if (!form) return;
    var honeypot = form.querySelector('input[name="website"]');
    var renderedAt = Date.now();
    var notice = null;

    form.addEventListener("submit", function (e) {
      if (honeypot && honeypot.value.trim() !== "") {
        e.preventDefault();
        e.stopImmediatePropagation();
        var done = document.createElement("p");
        done.className = "form-contact__message--success h4 col-span-6";
        done.textContent = honeypot.dataset.successMessage || "Thanks for reaching us!";
        form.replaceChildren(done);
        return;
      }
      if (Date.now() - renderedAt < MIN_FILL_MS) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (!notice) {
          notice = document.createElement("p");
          notice.className = "contact-form__notice col-span-6";
          notice.setAttribute("role", "alert");
          notice.textContent = "Please take a moment to review your information before submitting.";
        }
        form.insertBefore(notice, form.querySelector(".form-row--actions"));
        return;
      }
      if (notice) notice.remove();
    }, true);
  });
})();
